import { DescriptionOutlined, TrackChangesOutlined } from '@mui/icons-material'
import AssignmentIcon from '@mui/icons-material/Assignment'
import CancelIcon from '@mui/icons-material/Cancel'
import CategoryIcon from '@mui/icons-material/Category'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import EmailIcon from '@mui/icons-material/Email'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PersonIcon from '@mui/icons-material/Person'
import PhoneIcon from '@mui/icons-material/Phone'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import SaveIcon from '@mui/icons-material/Save'
import SettingsIcon from '@mui/icons-material/Settings'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Avatar,
    Card,
    Chip,
    Divider,
    IconButton,
    Button as MuiButton,
    Paper,
    Skeleton,
    Snackbar,
    Stack,
    Tooltip,
    Typography,
    useTheme,
} from '@mui/material'
import { STATUS_ON_HOLD_ID, STATUS_CLOSED_ID } from '../../Constants/StatusConstants'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid2'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { ArrowDropDownIcon } from '@mui/x-date-pickers'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
    ASSET_ITEM_DTO_URL,
    IMPACTS_URL,
    PRIORITIES_URL,
    REQUEST_TYPE_URL,
    RESOLVER_BY_RG_URL,
    RESOLVER_GROUP_BY_TICKET_CATEGORY_URL,
    SOURCE_TYPES_URL,
    STATUS_BY_ID_URL,
    STATUS_URL,
    TICKET_CATEGORIES_URL,
    TICKET_SLA_CLOCK_URL,
    TICKET_UPDATE_URL,
    TICKET_URL,
    URGENCIES_URL,
} from '../../Constants/Constants'
import { isEmpty } from '../../Constants/RolesConstants'
import { USER_ID } from '../../Constants/StorageConstants'
import AxiosInstance from '../../services/AxiosInstance'
import { fetchData } from '../../services/UtilService'
import { ThemeProvider } from '../v2/home/theme/ThemeProvider'
import { useAlert } from './../alerts//AlertContext'
import ClosureDialog from './ClosureDialog';

function EditTicket(props) {
    let { viewTicketId } = useParams()

    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    })

    const [subject, setSubject] = useState('')
    const [statusId, setStatusId] = useState('')
    const [statuses, setStatuses] = useState([])
    const [departmentId, setDepartmentId] = useState('')
    const [departments, setDepartments] = useState([])
    const [requestTypeId, setRequestTypeId] = useState('')
    const [requestTypes, setRequestTypes] = useState([])

    const [urgencyId, setUrgencyId] = useState('')
    const [urgencies, setUrgencies] = useState([])

    const [impactId, setImpactId] = useState('')
    const [impacts, setImpacts] = useState([])

    const [priorityId, setPriorityId] = useState('')
    const [priorities, setPriorities] = useState([])

    const [description, setDescription] = useState('')

    const [resolverGroupId, setResolverGroupId] = useState('')
    const [resolverGroups, setResolverGroups] = useState([])

    const [resolverId, setResolverId] = useState('')
    const [resolverUserId, setResolverUserId] = useState('')
    const [resolverName, setResolverName] = useState('')
    const [resolvers, setResolvers] = useState([])

    const [closureDialogOpen, setClosureDialogOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [slaClock, setSlaClock] = useState()
    const [businessHours, setBusinessHours] = useState({
        startTime: '09:00:00',
        endTime: '23:00:00',
        enabled: false,
    })

    const [assetItemId, setAssetItemId] = useState('')
    const [assetItemName, setAssetItemName] = useState('')
    const [assetItems, setAssetItems] = useState([])

    const [categoryId, setCategoryId] = useState('')
    const [categories, setCategories] = useState([])

    const [sourceTypeId, setSourceTypeId] = useState('')
    const [sourceTypes, setSourceTypes] = useState([])

    const [originalTicket, setOriginalTicket] = useState({});
    const [ticket, setTicket] = useState({});

    //New SLA start
    const [remainingResponseTime, setRemainingResponseTime] = useState(0);
    const [remainingResolveTime, setRemainingResolveTime] = useState(0);

    const initialized = useRef(false)

    const endTimeResponseRef = useRef(null)
    const intervalRef = useRef(null)
    const [, forceUpdate] = React.useReducer((x) => x + 1, 0)

    const endTimeResolveRef = useRef(null)


    //New SLA
    const getSlaColor = (status, timerRunning) => {
        switch (status) {
            case 'RUNNING':
                if (timerRunning === true)
                    return 'primary';   // Blue
                else
                    return 'warning';
            case 'MET':
                return 'success';   // Green
            case 'BREACHED':
                return 'error';     // Red
            case 'ON_HOLD':
                return 'warning';   // Orange
            default:
                return 'default';   // Grey (Waiting)
        }
    };

    const getSlaLabel = (status, timerRunning, remainingTimeInSeconds) => {
        switch (status) {
            case "RUNNING":
                if (timerRunning === true)
                    return `Running (${formatTime(remainingTimeInSeconds)})`;
                else
                    return `Paused (${formatTime(remainingTimeInSeconds)})`;
            case "MET":
                return "Met";

            case "BREACHED":
                return "Breached";

            case "ON_HOLD":
                return "On Hold";

            default:
                return "Waiting";
        }
    };


    //NEw SLA
    const isWithinBusinessHours = () => {

        if (!businessHours.enabled) {
            return true
        }
        if (statusId === STATUS_ON_HOLD_ID) {

            return false
        }
        const now = new Date()
        const currentTime = now.toTimeString().substring(0, 8)

        const currentSeconds = timeToSeconds(currentTime)
        const startSeconds = timeToSeconds(businessHours.startTime)
        const endSeconds = timeToSeconds(businessHours.endTime)

        let isWithin = false
        if (startSeconds <= endSeconds) {
            isWithin =
                currentSeconds >= startSeconds && currentSeconds <= endSeconds
        } else {
            isWithin =
                currentSeconds >= startSeconds || currentSeconds <= endSeconds
        }

        return isWithin
    }

    const timeToSeconds = (timeString) => {
        const [hours, minutes, seconds] = timeString.split(':').map(Number)
        return hours * 3600 + minutes * 60 + seconds
    }


    useEffect(() => {
        setLoading(true)
        if (!initialized.current) {
            initialized.current = true
            fetchData(SOURCE_TYPES_URL)
                .then((data) => setSourceTypes(data))
                .catch((err) => console.log('Failed to fetch source type data'))
            fetchData(TICKET_CATEGORIES_URL)
                .then((data) => setCategories(data.data))
                .catch((err) => console.log('Failed to fetch category data'))

            fetchData(URGENCIES_URL)
                .then((data) => setUrgencies(data))
                .catch((err) => console.log('Failed to fetch data'))
            fetchData(IMPACTS_URL)
                .then((data) => setImpacts(data))
                .catch((err) => console.log('Failed to fetch data'))

            fetchData(REQUEST_TYPE_URL)
                .then((data) => setRequestTypes(data))
                .catch((err) => console.log('Failed to fetch data'))
            fetchData(STATUS_URL)
                .then((data) => setStatuses(data))
                .catch((err) => console.log('Failed to fetch data'))
            fetchData(ASSET_ITEM_DTO_URL)
                .then((data) => setAssetItems(data.data))
                .catch((err) => console.log('Failed to fetch data'))
            fetchData(PRIORITIES_URL)
                .then((data) => setPriorities(data.data))
                .catch((err) => console.log('Failed to fetch data'))
            //fetchData(RESOLVER_GROUP_URL).then(data => setResolverGroups(data)).catch(err => console.log('Failed to fetch data'));
            getTicketInfo()
        }

    }, [refresh])

    const fetchSla = async () => {
        const res = await AxiosInstance.get(TICKET_SLA_CLOCK_URL + viewTicketId);

        setSlaClock(res.data);
        setRemainingResponseTime(res.data.responseRemainingMinutes * 60);
        setRemainingResolveTime(res.data.resolveRemainingMinutes * 60);
    };

    useEffect(() => {
        fetchSla();
    }, [viewTicketId, refresh]);

    useEffect(() => {

        if (!slaClock?.timerRunning) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }

        intervalRef.current = setInterval(() => {
            setRemainingResponseTime(prev => Math.max(prev - 1, 0));
            setRemainingResolveTime(prev => Math.max(prev - 1, 0));
        }, 1000);

        return () => {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        };

    }, [slaClock?.timerRunning]);

    const showAlert = useAlert()

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false })
    }

    const getTicketInfo = async () => {
        await AxiosInstance.get(`${TICKET_URL}/${viewTicketId}`).then((response) => {
            console.log(response.data)
            //setTicket(response.data);
            //setOriginalTicket(response.data);
            var ticketData = response.data
            setResolverUserId(ticketData.resolverUserId);
            setSubject(ticketData.subject);
            setDescription(ticketData.description);
            setRequestTypeId(ticketData.requestTypeId);
            setUrgencyId(ticketData.urgencyId);
            setImpactId(ticketData.impactId);
            setPriorityId(ticketData.priorityId);
            setStatusId(ticketData.statusId);
            setCategoryId(ticketData.ticketCategoryId);
            setResolverGroupId(ticketData.resolverGroupId);
            setSourceTypeId(ticketData.sourceTypeId);
            setAssetItemId(ticketData.assetItemId);

            setTicket({
                subject: ticketData.subject,
                description: ticketData.description,
                closureNotes: ticketData.closureNotes,
                requestType: {
                    id:
                        ticketData.requestTypeId === 0
                            ? null
                            : ticketData.requestTypeId,
                },
                urgency: {
                    id:
                        ticketData.urgencyId === 0
                            ? null
                            : ticketData.urgencyId,
                },
                impact: {
                    id: ticketData.impactId === 0 ? null : ticketData.impactId,
                },
                priority: {
                    id:
                        ticketData.priorityId === 0
                            ? null
                            : ticketData.priorityId,
                },
                status: { id: statusId === 0 ? null : ticketData.statusId },
                resolverGroup: {
                    id:
                        ticketData.resolverGroupId === 0
                            ? null
                            : ticketData.resolverGroupId,
                },
                resolver: { id: ticketData.resolverId },
                assetItem: {
                    id:
                        ticketData.assetItemId === 0
                            ? null
                            : ticketData.assetItemId,
                },
                ticketCategory: {
                    id:
                        ticketData.ticketCategoryId === 0
                            ? null
                            : ticketData.ticketCategoryId,
                },
                sourceType: {
                    id:
                        ticketData.sourceTypeId === 0
                            ? null
                            : ticketData.sourceTypeId,
                },
                organization: ticketData.organization,
                id: ticketData.id,
                createdOn: ticketData.createdOn,
                modifiedOn: ticketData.modifiedOn,
                departmentName: ticketData.departmentName,
                beHalfOfUser: ticketData.beHalfOfUser,
                createdBy: ticketData.createdBy,
            })

            setOriginalTicket({
                subject: ticketData.subject,
                description: ticketData.description,
                requestType: {
                    id:
                        ticketData.requestTypeId === 0
                            ? null
                            : ticketData.requestTypeId,
                },
                requestTypeId: {
                    id:
                        ticketData.urgencyId === 0
                            ? null
                            : ticketData.urgencyId,
                },
                impact: {
                    id: ticketData.impactId === 0 ? null : ticketData.impactId,
                },
                priority: {
                    id:
                        ticketData.priorityId === 0
                            ? null
                            : ticketData.priorityId,
                },
                status: { id: statusId === 0 ? null : ticketData.statusId },
                resolverGroup: {
                    id:
                        ticketData.resolverGroupId === 0
                            ? null
                            : ticketData.resolverGroupId,
                },
                resolver: { id: ticketData.resolverId },
                assetItem: {
                    id:
                        ticketData.assetItemId === 0
                            ? null
                            : ticketData.assetItemId,
                },
                ticketCategory: {
                    id:
                        ticketData.ticketCategoryId === 0
                            ? null
                            : ticketData.ticketCategoryId,
                },
                sourceType: {
                    id:
                        ticketData.sourceTypeId === 0
                            ? null
                            : ticketData.sourceTypeId,
                },
                organization: ticketData.organization,
                id: ticketData.id,
                createdOn: ticketData.createdOn,
                modifiedOn: ticketData.modifiedOn,
                departmentName: ticketData.departmentName,
                beHalfOfUser: ticketData.beHalfOfUser,
                createdBy: ticketData.createdBy,
            })

            if (ticketData?.resolverId) setResolverId(ticketData?.resolverId);

            if (
                ticketData?.resolverGroupId != null &&
                ticketData?.resolverGroupId != 0
            ) {
                AxiosInstance.get(
                    `${RESOLVER_BY_RG_URL}/${ticketData.resolverGroupId}`
                ).then((res) => setResolvers(res.data))
            }

            if (
                ticketData?.ticketCategoryId != null &&
                ticketData?.ticketCategoryId != 0
            ) {
                AxiosInstance.get(
                    `${RESOLVER_GROUP_BY_TICKET_CATEGORY_URL}/${ticketData.ticketCategoryId}`
                ).then((response) => setResolverGroups(response.data))
            }
            if (ticketData?.resolverGroupId)
                setResolverGroupId(ticketData.resolverGroupId)
            //AxiosInstance.get(TICKET_SLA_CLOCK_URL+viewTicketId).then(res => setSlaClock(res.data));

            fetchData(STATUS_BY_ID_URL + ticketData?.statusId)
                .then((data) => setStatuses(data))
                .catch((err) => console.log('Failed to fetch data'))

            setLoading(false)
        })
    }

    const handleSubjectChange = (event) => {
        setSubject(event.target.value)
    }

    const handleStatusChange = (event) => {

        const value = event.target.value;

        if (value === STATUS_CLOSED_ID) {
            setClosureDialogOpen(true);
            return;
        }

        setStatusId(value);
    }

    const handleRequestTypeChange = (event) => {
        setRequestTypeId(event.target.value);
    }

    const handleUrgencyChange = (event) => {
        setUrgencyId(event.target.value);
    }

    const handleImpactChange = (event) => {
        setImpactId(event.target.value);
    }

    const handlePriorityChange = (event) => {
        setPriorityId(event.target.value);
    }

    const handleResolverGroupChange = (event) => {
        setResolverGroupId(event.target.value)
        const id = event.target.value;
        console.log('resolver url:' + `${RESOLVER_BY_RG_URL}/${event.target.value}`)

        if (!id) {
            setResolvers([])
            return
        }

        AxiosInstance.get(`${RESOLVER_BY_RG_URL}/${event.target.value}`).then(
            (response) => setResolvers(response.data)
        )
    }

    const handleResolverChange = (event) => {
        setResolverId(event.target.value);
    }

    const handleAssetItemChange = (event) => {
        setAssetItemId(event.target.value);
    }

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value)
    }

    const handleCategoryChange = (event) => {
        setCategoryId(event.target.value);
        console.log(
            'resolver group url:' +
            RESOLVER_GROUP_BY_TICKET_CATEGORY_URL +
            event.target.value
        )
        AxiosInstance.get(
            `${RESOLVER_GROUP_BY_TICKET_CATEGORY_URL}/${event.target.value}`
        ).then((response) => setResolverGroups(response.data))
    }

    const handleSourceTypeChange = (event) => {
        setSourceTypeId(event.target.value)
    }

    const handleCancel = () => {
        setTicket(originalTicket)
        showAlert('Changes cancelled.', 'info')
    }

    const handleSubmit = (event, closureData = null) => {
        if (event) {
            event.preventDefault();
        }

        const payload = {};

        let hasChanges = statusId !== (ticket.status?.id || 0) || resolverGroupId !== (ticket.resolverGroup?.id || 0) || resolverId !== (ticket.resolver?.id || 0)
            || categoryId !== (ticket.ticketCategory?.id || 0) || assetItemId !== (ticket.assetItem?.id || 0) || urgencyId !== (ticket.urgency?.id || 0)
            || impactId !== (ticket.impact?.id || 0) || description !== ticket.description;

        if (closureData) {
            hasChanges = true;
            setStatusId(STATUS_CLOSED_ID);
            payload.status = { id: STATUS_CLOSED_ID };
            payload.closureNotes = closureData;
        } else {
            if (ticket.closureNotes)
                payload.closureNotes = ticket.closureNotes;

            payload.status = { id: statusId };
        }

        if (!hasChanges) {
            showAlert('No modifications detected.', 'info')
            return;
        }

        if (resolverGroupId === '' && resolverId === '') {
            setSnackbar({
                open: true,
                message: 'Please select Resolver Group and Resolver',
                severity: 'error',
            })
            return false
        } else if (resolverId === '') {
            setSnackbar({
                open: true,
                message: 'Please select Resolver',
                severity: 'error',
            })
            return false
        }

        setSaving(true)


        payload.id = viewTicketId;
        payload.subject = subject;
        payload.description = description;
        payload.requestType = { id: requestTypeId };
        payload.urgency = { id: urgencyId };
        payload.impact = { id: impactId };
        payload.priority = { id: priorityId };
        payload.ticketCategory = { id: categoryId };
        payload.resolverGroup = { id: resolverGroupId };


        if (resolverId !== '')
            payload.resolver = {
                id: resolverId,
                user: { id: resolverName },
                resolverGroup: { id: resolverGroupId },
            }
        else payload.resolver = { id: resolverId }

        payload.assetItem = { id: assetItemId }
        // if (assetItemId !== '') updateTicket.assetItem = { id: assetItemId }
        // else updateTicket.assetItem = { id: ticket ?.assetItem ?.id }

        saveTicket(payload)

        console.log(payload);
    }

    const saveTicket = (payload) => {
        AxiosInstance.put(TICKET_UPDATE_URL, payload)
            .then((response) => {
                setSaving(false)

                //getTicketInfo();      // reload ticket
                // TODO: update sla clock
                //fetchEndTime()

                //if (isWithinBusinessHours()) {
                //fetchSla();
                setClosureDialogOpen(false);
                initialized.current = false;
                setRefresh(prev => !prev);

                setSnackbar({
                    open: true,
                    message: 'Ticket updated successfully!',
                    severity: 'success',
                })
                //}
            })
            .catch((error) => {
                setSaving(false)
                setSnackbar({
                    open: true,
                    message: 'Ticket update failed!',
                    severity: 'error',
                })
                console.error(error)
            })
    }

    const formatTime = (totalSeconds) => {
        //let totalSeconds = Math.floor(ms / 1000)
        let hours = Math.floor(totalSeconds / 3600)
        let minutes = Math.floor((totalSeconds % 3600) / 60)
        let seconds = totalSeconds % 60
        return `${hours}h ${minutes}m ${seconds}s`
    }
    const theme = useTheme()
    const [copied, setCopied] = useState(false)

    if (loading) {
        return (
            <Box
                sx={{
                    p: 6,
                    mx: 'auto',
                    bgcolor: theme.palette.background.default,
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* SLA Status Section Skeleton */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width="20%"
                            height={32}
                            sx={{ mb: 2 }}
                        />
                        <Grid container spacing={3}>
                            <Grid xs={12} md={6}>
                                <Skeleton
                                    variant="rectangular"
                                    height={40}
                                    sx={{ borderRadius: 1 }}
                                />
                            </Grid>
                            <Grid xs={12} md={6}>
                                <Skeleton
                                    variant="rectangular"
                                    height={40}
                                    sx={{ borderRadius: 1 }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Ticket Details Section Skeleton */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width="25%"
                            height={32}
                            sx={{ mb: 2 }}
                        />
                        <Grid container spacing={3}>
                            <Grid xs={12}>
                                <Skeleton
                                    variant="rectangular"
                                    height={56}
                                    sx={{ borderRadius: 1 }}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Skeleton
                                    variant="rectangular"
                                    height={120}
                                    sx={{ borderRadius: 1 }}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Skeleton
                                    variant="rectangular"
                                    height={56}
                                    sx={{ borderRadius: 1 }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Classification Section Skeleton */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width="30%"
                            height={32}
                            sx={{ mb: 2 }}
                        />
                        <Grid container spacing={3}>
                            {[...Array(4)].map((_, i) => (
                                <Grid xs={12} md={6} key={i}>
                                    <Skeleton
                                        variant="rectangular"
                                        height={56}
                                        sx={{ borderRadius: 1 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Priority & Impact Section Skeleton */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width="35%"
                            height={32}
                            sx={{ mb: 2 }}
                        />
                        <Grid container spacing={3}>
                            {[...Array(3)].map((_, i) => (
                                <Grid xs={12} md={4} key={i}>
                                    <Skeleton
                                        variant="rectangular"
                                        height={56}
                                        sx={{ borderRadius: 1 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Assignment Section Skeleton */}
                    <Box>
                        <Skeleton
                            variant="text"
                            width="25%"
                            height={32}
                            sx={{ mb: 2 }}
                        />
                        <Grid container spacing={3}>
                            {[...Array(3)].map((_, i) => (
                                <Grid xs={12} md={6} key={i}>
                                    <Skeleton
                                        variant="rectangular"
                                        height={56}
                                        sx={{ borderRadius: 1 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Action Buttons Skeleton */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Skeleton
                            variant="rectangular"
                            width={100}
                            height={48}
                            sx={{ borderRadius: 2 }}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={150}
                            height={48}
                            sx={{ borderRadius: 2 }}
                        />
                    </Box>
                </Box>
            </Box>
        )
    }

    const statusColors = {
        open: '#007BFF',
        'in-progress': '#FD7E14',
        hold: '#FFC107',
        resolved: '#20C997',
        closed: '#6C757D',
    }
    const statusTextColors = {
        open: '#fff',
        'in-progress': '#fff',
        hold: '#000',
        resolved: '#fff',
        closed: '#fff',
    }

    const selectedStatus = statuses.find(
        (status) => status.id === ticket?.status?.id
    )

    return (
        <ThemeProvider>
            <Box sx={{ p: 3, bgcolor: theme.palette.background.default }}>
                {/* Header Bar */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mb: 1,
                    }}
                >
                    <Box>
                        <Grid container spacing={3}>
                            {/* Response SLA */}
                            <Grid xs={12} md={6}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Box sx={{ minWidth: 100 }}>
                                        <Typography
                                            variant="subtitle2"
                                            color="text.secondary"
                                        >
                                            Response SLA
                                        </Typography>
                                    </Box>
                                    <Chip
                                        label={getSlaLabel(slaClock?.responseStatus, slaClock?.timerRunning, remainingResponseTime)}
                                        color={getSlaColor(slaClock?.responseStatus, slaClock?.timerRunning)}
                                        variant="filled"
                                        size="small"
                                        sx={{
                                            fontWeight: 600,
                                            minWidth: 80,
                                            '& .MuiChip-label': {
                                                px: 1,
                                            },
                                        }}
                                    />
                                </Stack>
                            </Grid>

                            {/* Resolve SLA */}
                            <Grid xs={12} md={6}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Box sx={{ minWidth: 86 }}>
                                        <Typography
                                            variant="subtitle2"
                                            color="text.secondary"
                                        >
                                            Resolve SLA
                                        </Typography>
                                    </Box>
                                    <Chip
                                        label={getSlaLabel(slaClock?.resolveStatus, slaClock?.timerRunning, remainingResolveTime)}
                                        color={getSlaColor(slaClock?.resolveStatus, slaClock?.timerRunning)}
                                        variant="filled"
                                        size="small"
                                        sx={{
                                            fontWeight: 600,
                                            minWidth: 80,
                                            '& .MuiChip-label': {
                                                px: 1,
                                            },
                                        }}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>

                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        sx={{ justifyItems: 'center' }}
                    >
                        <Chip
                            icon={
                                ticket?.sourceType?.name === 'Email' ? (
                                    <EmailIcon />
                                ) : (
                                    <PhoneIcon />
                                )
                            }
                            label={ticket?.sourceType?.name || '-'}
                            size="small"
                            color="success"
                        />
                        <Chip
                            icon={<CategoryIcon />}
                            label={
                                requestTypes.find(
                                    (rt) => rt.id === ticket?.requestType?.id
                                )?.name || '-'
                            }
                            size="small"
                        />
                        <Chip
                            icon={<PriorityHighIcon />}
                            label={
                                priorities.find(
                                    (p) => p.id === ticket?.priority?.id
                                )?.name || '-'
                            }
                            size="small"
                            color="warning"
                        />
                        <Chip
                            icon={<TrackChangesOutlined />}
                            label={selectedStatus?.name || '-'}
                            size="small"
                            sx={{
                                bgcolor:
                                    statusColors[
                                    selectedStatus?.name?.toLowerCase()
                                    ],
                                color: statusTextColors[
                                    selectedStatus?.name?.toLowerCase()
                                ],
                            }}
                        />
                    </Stack>
                </Box>
                {/* Two-Column Layout */}
                <Grid
                    container
                    spacing={4}
                    sx={{ justifyContent: 'space-between' }}
                >
                    {/* LEFT COLUMN: Main Content */}
                    <Grid item xs={12} md={7} sx={{ flex: 1 }}>
                        <Stack spacing={2}>
                            {/* Basic Information Section */}

                            {/* SLA Status Section */}
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{ maxWidth: '40%' }}
                            >
                                {/* overflow text */}
                                <Typography
                                    variant="h5"
                                    fontWeight={700}
                                    sx={{
                                        mb: 1,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {ticket?.subject || 'Ticket Summary'}
                                </Typography>
                            </Stack>

                            <Box>
                                {/* Description Section */}
                                <Box>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                        sx={{ mb: 1 }}
                                    >
                                        <DescriptionOutlined
                                            color="primary"
                                            fontSize="small"
                                        />
                                        <Typography
                                            variant="subtitle1"
                                            color="text.primary"
                                            sx={{ fontWeight: 600 }}
                                        >
                                            Description
                                        </Typography>
                                    </Stack>
                                    <Box
                                        sx={{
                                            bgcolor: 'background.default',
                                            p: 1.5,
                                            borderRadius: 1,
                                            minHeight: 200,
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            border: '1px solid',
                                            borderColor: 'divider',
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word',
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {description || '-'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            <Box>
                                {/* Description Section */}
                                <Box>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <PersonIcon
                                            color="primary"
                                            fontSize="small"
                                        />
                                        <Typography
                                            variant="subtitle1"
                                            color="text.primary"
                                            sx={{ fontWeight: 600 }}
                                        >
                                            Reporter Information
                                        </Typography>
                                    </Stack>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        sx={{ gap: 2 }}
                                    >
                                        {/* Name */}
                                        <Box>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                Name
                                            </Typography>
                                            <Stack
                                                direction="row"
                                                spacing={1.5}
                                                alignItems="center"
                                            >
                                                <Avatar
                                                    sx={{
                                                        width: 32,
                                                        height: 32,
                                                        bgcolor: 'primary.main',
                                                    }}
                                                >
                                                    {ticket?.createdBy
                                                        ? ticket.createdBy[0]
                                                        : 'R'}
                                                </Avatar>
                                                <Typography
                                                    variant="body2"
                                                    sx={{ fontWeight: 500 }}
                                                >
                                                    {ticket?.createdBy ||
                                                        'Reporter'}
                                                </Typography>
                                            </Stack>
                                        </Box>

                                        {/* Department & Organization */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                Department
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    bgcolor:
                                                        'background.default',
                                                    borderRadius: 1,
                                                    fontSize: '0.875rem',
                                                }}
                                            >
                                                {ticket?.departmentName || 'NA'}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                Organization
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    bgcolor:
                                                        'background.default',
                                                    borderRadius: 1,
                                                    fontSize: '0.875rem',
                                                }}
                                            >
                                                {ticket?.organization || 'NA'}
                                            </Typography>
                                        </Box>

                                        {/* On Behalf Of */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                On Behalf Of
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{ fontWeight: 500 }}
                                            >
                                                {ticket?.beHalfOfUser ||
                                                    'Not available'}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                            </Box>

                            {/* Additional Details Accordion */}
                            <Accordion
                                sx={{
                                    display: 'none',
                                    boxShadow: 1,
                                    borderRadius: 2,
                                    '&:before': { display: 'none' },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        '&:hover': { bgcolor: 'action.hover' },
                                        borderRadius: 2,
                                        py: 0.5,
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <SettingsIcon
                                            color="action"
                                            fontSize="small"
                                        />
                                        <Typography
                                            variant="subtitle2"
                                            sx={{ fontWeight: 600 }}
                                        >
                                            Additional Details
                                        </Typography>
                                        <Chip
                                            label="3 fields"
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                        />
                                    </Stack>
                                </AccordionSummary>
                                <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                                    <Grid container spacing={2}>
                                        {/* Asset Item */}
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Asset Item
                                            </Typography>
                                            <FormControl fullWidth size="small">
                                                <Select
                                                    value={
                                                        assetItemId ||
                                                        ''
                                                    }
                                                    onChange={
                                                        handleAssetItemChange
                                                    }
                                                >
                                                    <MenuItem value="">
                                                        <em>
                                                            Select Asset Item
                                                        </em>
                                                    </MenuItem>
                                                    {assetItems.map((ai) => (
                                                        <MenuItem
                                                            key={ai.id}
                                                            value={ai.id}
                                                        >
                                                            {ai.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>

                            <Divider
                                variant="middle"
                                component="div"
                                sx={{ my: 2, borderColor: 'divider' }}
                            />

                            {/* System Information - always visible, no background, no dividers */}
                            <Paper
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    border: 'none',
                                    boxShadow: 'none',
                                    bgcolor: 'transparent',
                                }}
                            >
                                <Stack direction="column" spacing={2}>
                                    {/* First row: Created and Modified */}
                                    <Stack
                                        direction="row"
                                        spacing={4}
                                        alignItems="center"
                                    >
                                        {/* Created Date */}
                                        <Box>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                Created
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: '0.95rem',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {ticket?.createdOn
                                                    ? new Date(
                                                        ticket.createdOn
                                                    ).toLocaleDateString(
                                                        'en-US',
                                                        {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                        }
                                                    )
                                                    : '-'}
                                            </Typography>
                                        </Box>
                                        {/* Modified Date */}
                                        <Box>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.5,
                                                }}
                                            >
                                                Modified
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontSize: '0.95rem',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {ticket?.modifiedOn
                                                    ? new Date(
                                                        ticket.modifiedOn
                                                    ).toLocaleDateString(
                                                        'en-US',
                                                        {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                        }
                                                    )
                                                    : '-'}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    {/* Second row: Ticket ID */}
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={0.5}
                                        sx={{ p: 1.5, pl: 0 }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontWeight: 700,
                                                letterSpacing: 0.5,
                                            }}
                                        >
                                            Ticket ID:
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontFamily: 'monospace',
                                                fontWeight: 500,
                                                fontSize: '0.95rem',
                                            }}
                                        >
                                            {ticket?.id || '-'}
                                        </Typography>
                                        {ticket?.id && (
                                            <Tooltip
                                                title={
                                                    copied
                                                        ? 'Copied!'
                                                        : 'Copy Ticket ID'
                                                }
                                                arrow
                                            >
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(
                                                            ticket.id
                                                        )
                                                        setCopied(true)
                                                        setTimeout(
                                                            () =>
                                                                setCopied(
                                                                    false
                                                                ),
                                                            1200
                                                        )
                                                    }}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    {copied ? (
                                                        <CheckCircleIcon
                                                            color="success"
                                                            fontSize="small"
                                                        />
                                                    ) : (
                                                        <ContentCopyIcon fontSize="small" />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Stack>
                                    <stack direction="row"
                                        alignItems="center"
                                        spacing={0.5}
                                        sx={{ p: 1.5, pl: 0 }}>
                                        {ticket.closureNotes && (
                                            <>
                                                <Typography variant="caption"
                                                    color="text.secondary"
                                                    sx={{
                                                        fontWeight: 700,
                                                        letterSpacing: 0.5,
                                                    }}>
                                                    Resolution Notes:
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontFamily: 'monospace',
                                                        fontWeight: 500,
                                                        fontSize: '0.95rem',
                                                    }}
                                                >
                                                    {ticket.closureNotes}
                                                </Typography>
                                            </>
                                        )}
                                    </stack>
                                </Stack>
                            </Paper>
                        </Stack>
                    </Grid>

                    {/* RIGHT COLUMN: Reporter Info, Assignment */}
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{ minWidth: { md: 400 }, width: '35%' }}
                    >
                        <Stack spacing={2}>
                            {/* Status Section */}
                            <Card
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                    boxShadow: 1,
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ mb: 0.5 }}
                                >
                                    <TrackChangesOutlined
                                        color="primary"
                                        fontSize="small"
                                    />
                                    <Typography
                                        variant="subtitle1"
                                        color="text.primary"
                                        sx={{ fontWeight: 600 }}
                                    >
                                        Status
                                    </Typography>
                                </Stack>

                                <Box sx={{ width: '47%' }}>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{
                                            mb: 0.5,
                                            display: 'block',
                                            fontWeight: 500,
                                        }}
                                    >
                                        Status
                                    </Typography>
                                    <FormControl
                                        size="small"
                                        sx={{
                                            width: '100%',
                                            minWidth: 120,
                                            '& .MuiOutlinedInput-root': {
                                                height: 32,
                                                '& .MuiSelect-select': {
                                                    fontSize: '0.75rem',
                                                    fontWeight: 500,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '100%',
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            id="status-select"
                                            value={statusId || ''}
                                            onChange={handleStatusChange}
                                            renderValue={(selected) => {
                                                const selectedStatus =
                                                    statuses.find(
                                                        (status) =>
                                                            status.id ===
                                                            selected
                                                    )
                                                return (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontWeight: 500 }}
                                                    >
                                                        {selectedStatus?.name}
                                                    </Typography>
                                                )
                                            }}
                                            inputProps={{
                                                IconComponent:
                                                    ArrowDropDownIcon,
                                            }}
                                        >
                                            {statuses.map((status) => (
                                                <MenuItem
                                                    key={status.id}
                                                    value={status.id}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontWeight: 500 }}
                                                    >
                                                        {status.name}
                                                    </Typography>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Card>
                            {/* Assignment Section */}
                            <Card
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                    boxShadow: 1,
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ mb: 0.5 }}
                                >
                                    <AssignmentIcon
                                        color="primary"
                                        fontSize="small"
                                    />
                                    <Typography
                                        variant="subtitle1"
                                        color="text.primary"
                                        sx={{ fontWeight: 600 }}
                                    >
                                        Assignment
                                    </Typography>
                                </Stack>

                                <Grid container spacing={2}>
                                    {/* Resolver Group */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Resolver Group
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                minWidth: 120,
                                                '& .MuiOutlinedInput-root': {
                                                    height: 32,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                disabled={statusId === STATUS_CLOSED_ID}
                                                value={
                                                    resolverGroupId ||
                                                    ''
                                                }
                                                onChange={
                                                    handleResolverGroupChange
                                                }
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedResolverGroup =
                                                        resolverGroups.find(
                                                            (rg) =>
                                                                rg.id ===
                                                                selected
                                                        )
                                                    return (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 500,
                                                                overflow:
                                                                    'hidden',
                                                                textOverflow:
                                                                    'ellipsis',
                                                                whiteSpace:
                                                                    'nowrap',
                                                            }}
                                                        >
                                                            {selectedResolverGroup?.name ||
                                                                'Select Resolver Group'}
                                                        </Typography>
                                                    )
                                                }}
                                                inputProps={{
                                                    IconComponent:
                                                        ArrowDropDownIcon,
                                                }}
                                            >
                                                <MenuItem
                                                    key="select-group"
                                                    value=""
                                                >
                                                    <em>
                                                        Select Resolver Group
                                                    </em>
                                                </MenuItem>
                                                {resolverGroups.map((rg) => (
                                                    <MenuItem
                                                        key={rg.id}
                                                        value={rg.id}
                                                    >
                                                        {rg.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Resolver */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Resolver
                                        </Typography>
                                        <Grid
                                            container
                                            alignItems="center"
                                            spacing={1.5}
                                            sx={{ width: '100%' }}
                                        >
                                            <Grid item>
                                                <Avatar
                                                    sx={{
                                                        width: 32,
                                                        height: 32,
                                                        bgcolor:
                                                            'secondary.main',
                                                    }}
                                                >
                                                    {resolvers.find(
                                                        (r) =>
                                                            r.id ===
                                                            ticket?.resolver?.id
                                                    )?.user?.name
                                                        ? resolvers.find(
                                                            (r) =>
                                                                r.id ===
                                                                ticket
                                                                    ?.resolver
                                                                    ?.id
                                                        ).user.name[0]
                                                        : 'A'}
                                                </Avatar>
                                            </Grid>
                                            <Grid
                                                item
                                                xs
                                                sx={{
                                                    width: 'calc(100% - 46px)',
                                                }}
                                            >
                                                <FormControl
                                                    size="small"
                                                    sx={{
                                                        width: '100%',
                                                        minWidth: 120,
                                                        '& .MuiOutlinedInput-root':
                                                        {
                                                            height: 32,
                                                            '& .MuiSelect-select':
                                                            {
                                                                fontSize:
                                                                    '0.75rem',
                                                                fontWeight: 500,
                                                                display:
                                                                    'flex',
                                                                alignItems:
                                                                    'center',
                                                                height: '100%',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Select
                                                        disabled={statusId === STATUS_CLOSED_ID}
                                                        value={
                                                            resolverId || ''
                                                        }
                                                        onChange={
                                                            handleResolverChange
                                                        }
                                                        displayEmpty
                                                        renderValue={(
                                                            selected
                                                        ) => {
                                                            const selectedResolver =
                                                                resolvers.find(
                                                                    (r) =>
                                                                        r.id ===
                                                                        selected
                                                                )
                                                            return (
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 500,
                                                                        overflow:
                                                                            'hidden',
                                                                        textOverflow:
                                                                            'ellipsis',
                                                                        whiteSpace:
                                                                            'nowrap',
                                                                        maxWidth: 150,
                                                                    }}
                                                                >
                                                                    {selectedResolver?.name ||
                                                                        'Select Resolver'}
                                                                </Typography>
                                                            )
                                                        }}
                                                        inputProps={{
                                                            IconComponent:
                                                                ArrowDropDownIcon,
                                                        }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>
                                                                Select Resolver
                                                            </em>
                                                        </MenuItem>
                                                        {resolvers.map(
                                                            (res) => (
                                                                <MenuItem
                                                                    key={res.id}
                                                                    value={
                                                                        res.id
                                                                    }
                                                                >
                                                                    {res.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Card>

                            {/* Classification Section */}
                            <Card
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                    boxShadow: 1,
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ mb: 1 }}
                                >
                                    <CategoryIcon
                                        color="primary"
                                        fontSize="small"
                                    />
                                    <Typography
                                        variant="subtitle1"
                                        color="text.primary"
                                        sx={{ fontWeight: 600 }}
                                    >
                                        Classification
                                    </Typography>
                                </Stack>

                                <Grid container spacing={2}>
                                    {/* Category */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Category
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                // minWidth: 120,
                                                '& .MuiOutlinedInput-root': {
                                                    height: 32,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                disabled={statusId === STATUS_CLOSED_ID}
                                                value={
                                                    categoryId || ''
                                                }
                                                onChange={handleCategoryChange}
                                                renderValue={(selected) => {
                                                    const selectedCategory =
                                                        categories.find(
                                                            (cat) =>
                                                                cat.id ===
                                                                selected
                                                        )
                                                    return (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {selectedCategory?.name ||
                                                                '-'}
                                                        </Typography>
                                                    )
                                                }}
                                                inputProps={{
                                                    IconComponent:
                                                        ArrowDropDownIcon,
                                                }}
                                            >
                                                {categories.map((cat) => (
                                                    <MenuItem
                                                        key={cat.id}
                                                        value={cat.id}
                                                    >
                                                        {cat.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* Asset Item */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Asset Item
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                minWidth: 120,
                                                '& .MuiOutlinedInput-root': {
                                                    height: 32,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                disabled={statusId === STATUS_CLOSED_ID}
                                                width="100%"
                                                value={
                                                    assetItemId || ''
                                                }
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    const selectedAssetItem =
                                                        assetItems.find(
                                                            (ai) =>
                                                                ai.id ===
                                                                selected
                                                        )
                                                    return (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {selectedAssetItem?.name ||
                                                                'Select Asset Item'}
                                                        </Typography>
                                                    )
                                                }}
                                                onChange={handleAssetItemChange}
                                                inputProps={{
                                                    IconComponent:
                                                        ArrowDropDownIcon,
                                                }}
                                            >
                                                <MenuItem value="">
                                                    Select Asset Item
                                                </MenuItem>
                                                {assetItems.map((ai) => (
                                                    <MenuItem
                                                        key={ai.id}
                                                        value={ai.id}
                                                    >
                                                        {ai.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Card>

                            {/* Priority & Impact Analysis Section */}
                            <Card
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                    boxShadow: 1,
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    sx={{ mb: 1 }}
                                >
                                    <PriorityHighIcon
                                        color="primary"
                                        fontSize="small"
                                    />
                                    <Typography
                                        variant="subtitle1"
                                        color="text.primary"
                                        sx={{ fontWeight: 600 }}
                                    >
                                        Priority & Impact Analysis
                                    </Typography>
                                </Stack>

                                <Grid container spacing={2}>
                                    {/* Urgency */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Urgency
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                minWidth: 120,
                                                '& .MuiOutlinedInput-root': {
                                                    height: 32,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                    },
                                                },
                                            }}
                                        >
                                            <Select
                                                disabled={statusId === STATUS_CLOSED_ID}
                                                value={
                                                    ticket?.urgency?.id || ''
                                                }
                                                onChange={handleUrgencyChange}
                                                inputProps={{
                                                    IconComponent:
                                                        ArrowDropDownIcon,
                                                }}
                                                renderValue={(selected) => {
                                                    const selectedUrgency =
                                                        urgencies.find(
                                                            (u) =>
                                                                u.id ===
                                                                selected
                                                        )
                                                    return (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {selectedUrgency?.name ||
                                                                '-'}
                                                        </Typography>
                                                    )
                                                }}
                                            >
                                                {urgencies.map((urgency) => (
                                                    <MenuItem
                                                        key={urgency.id}
                                                        value={urgency.id}
                                                    >
                                                        {urgency.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* Impact */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        sx={{ width: '47%' }}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mb: 0.5,
                                                display: 'block',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Impact
                                        </Typography>
                                        <FormControl
                                            sx={{
                                                width: '100%',
                                                minWidth: 120,
                                                '& .MuiOutlinedInput-root': {
                                                    height: 32,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        height: '100%',
                                                    },
                                                },
                                            }}
                                            size="small"
                                        >
                                            <Select
                                                disabled={statusId === STATUS_CLOSED_ID}
                                                value={ticket?.impact?.id || ''}
                                                onChange={handleImpactChange}
                                                inputProps={{
                                                    IconComponent:
                                                        ArrowDropDownIcon,
                                                }}
                                                renderValue={(selected) => {
                                                    const selectedImpact =
                                                        impacts.find(
                                                            (i) =>
                                                                i.id ===
                                                                selected
                                                        )
                                                    return (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {selectedImpact?.name ||
                                                                '-'}
                                                        </Typography>
                                                    )
                                                }}
                                            >
                                                {impacts.map((impact) => (
                                                    <MenuItem
                                                        key={impact.id}
                                                        value={impact.id}
                                                    >
                                                        {impact.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Stack>
                    </Grid>
                </Grid>
                {/* Action Buttons */}
                {isEmpty(props?.componentPermissions) ||
                    props?.componentPermissions?.['canUpdate'] ? (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'flex-end',
                            mt: 4,
                        }}
                    >
                        <MuiButton
                            variant="outlined"
                            startIcon={<CancelIcon />}
                            onClick={handleCancel}
                            size="large"
                            sx={{ minWidth: 120, display: 'none' }}
                        >
                            Cancel
                        </MuiButton>
                        <MuiButton
                            variant="contained"
                            startIcon={<SaveIcon />}
                            onClick={handleSubmit}
                            disabled={
                                saving ||
                                (resolverUserId !== '' &&
                                    localStorage.getItem(USER_ID) !==
                                    resolverUserId)
                            }
                            size="large"
                            sx={{
                                minWidth: 150,
                                background:
                                    'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
                                boxShadow:
                                    '0 3px 5px 2px rgba(25, 118, 210, .3)',
                                '&:hover': {
                                    background:
                                        'linear-gradient(45deg, #1565c0 30%, #1976d2 90%)',
                                },
                            }}
                        >
                            {saving ? 'Updating...' : 'Update Ticket'}
                        </MuiButton>
                    </Box>
                ) : null}
                {/* Snackbar for notifications */}
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>

                <ClosureDialog
                    open={closureDialogOpen}
                    onClose={() => setClosureDialogOpen(false)}
                    onSave={(notes) => {
                        handleSubmit(null, notes);
                    }}
                />
            </Box>
        </ThemeProvider>
    )
}

export default EditTicket
